<template>
  <div class="left-pane" :class="{collapsed: !!$root.isMenuCollapsed}" style="top:0">
    <Logo/>
    <SearchBox v-model="filterMenuKeyword" v-if="isShowMenuSearchBox"/>
    <el-menu
      mode="vertical"
      ref="menu"
      :collapse="$root.isMenuCollapsed"
      :router="false"
      :default-active="currentRoutePath"
      :default-openeds="openedMenus"
      @select="onSelectMenuItem"
      class="left-main-menu"
    >
      <McMenuItem v-for="(item, index) in filteredMenu" :meta="item" :key="index"/>
      <li v-if="!(filteredMenu && filteredMenu.length)" class="empty-content">
        未找到菜单
      </li>
    </el-menu>
  </div>
</template>

<script>
  import siteOptions from '@/config/index'
  import { filterMenusByKeyword, getMenusLeafCount, getMenusOpenedIndexes } from '@/framework/utils/layout'
  import { mainMenuConfig } from '@/config/menu';
  import { filterMenu } from '@/framework/utils/perm'
  import Logo from '@/framework/components/Logo.vue'
  import SearchBox from '@/framework/components/SearchBox'
  import McMenuItem from '@/framework/components/McMenuItem'
  import { mapGetters } from 'vuex'
  const env = (() => {
  if (/dev/.test(location.hostname)) {
    return ".stage";
  } else if (/test/.test(location.hostname)) {
    return ".stage";
  } else if (/stage/.test(location.hostname)) {
    return ".stage";
  }
  return "";
  })();
  export default {
    name: 'SideBar',
    data() {
      return {
        mainMenuConfig : [],
        currentRoutePath: this.getCurrentRoutePath(),
        filterMenuKeyword: ''
      }
    },
    watch: {
      '$route': {
        handler(){
          this.currentRoutePath = this.getCurrentRoutePath()
        }
      },
      'userInfo': {
        immediate: true,
        handler(val) {
          let { showMenu, isShowPurchase } = val;
          if (!(showMenu && isShowPurchase) && this.mainMenuConfig) {
            this.mainMenuConfig = this.mainMenuConfig.filter(menu => menu.name !== '商品管理')
          }
          if ((showMenu && isShowPurchase) && this.mainMenuConfig) {
            if(!this.mainMenuConfig.some(menu => menu.name === '商品管理')) {
              this.mainMenuConfig.splice(3, 0, {
                name: "商品管理",
                icon: "el-icon-shopping-cart-full",
                path: "/products",
                children: [
                  {
                    name: "采购单管理",
                    path: `/iframe/?url=https://keyclient${env}.yunshanmeicai.com/purchaseListConfig/purchaseListIndex`
                  }
                ]
              })
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters(["userInfo"]),
      filteredMenu() {
        return filterMenusByKeyword(this.mainMenuConfig, this.filterMenuKeyword)
      },
      isShowMenuSearchBox(){
        return siteOptions['isShowMenuSearchBox'] && !this.$root.isMenuCollapsed &&
          ( this.menusCount > siteOptions['whenShowMenuSearchBox'] || this.filterMenuKeyword )
      },
      menusCount(){
        return getMenusLeafCount(this.filteredMenu)
      },
      openedMenus(){
        if(this.filterMenuKeyword){
          return getMenusOpenedIndexes(this.filteredMenu)
        } else {
          return []
        }
      }
    },
    mounted(){
      filterMenu(mainMenuConfig).then(menus=>{
        this.mainMenuConfig = menus
      })
    },
    methods: {
      getCurrentRoutePath(){
        let routeMeta = this.$route.meta || {}
        return decodeURIComponent(routeMeta['menu'] || this.$route.fullPath || '/')
      },
      onSelectMenuItem(path){
        if(path && path.indexOf('http') === 0){
          this.$refs.menu.updateActiveIndex(this.$route.fullPath)
          window.open(path)
        } else {
          this.$router.push({
            path: path,
            query: {}
          })
          this.currentRoutePath = path
        }
      }
    },
    components: {
      Logo, SearchBox, McMenuItem
    }
  }
</script>
